import {BasicLineChart} from "./plotly/BasicLineChart";

export const KpiTrendChart = ({title, valueField, data, previousPeriodData, filters}) => {
    return (
        <BasicLineChart
            title={title}
            valueField={valueField}
            data={data}
            previousPeriodData={previousPeriodData}
            showTitle={true}
            showPaper={true}
            height={280}
            responsive={true}
        />
    );
};